module.exports = __webpack_public_path__ + "static/media/white_noun-553134-cc.37c6353f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/white_noun-553134-cc.svg
// module id = 258
// module chunks = 0